export interface TeamInterface {
  guid: string;
  id: string;
  name: string;
  owner?: {
    guid: string;
    name: string;
  };
  createdAt: Date;
  own: boolean;
  autoShare: boolean;
  accessLevel: AccessLevelEnum;
  shareType: TeamShareTypeEnum;
}

export enum AccessLevelEnum {
  ADMINISTRATOR = 'administrator',
  MANAGER = 'manager',
  OWNER = 'owner',
  VIEWER = 'viewer',
}

export enum TeamShareTypeEnum {
  PRIVATE = 'private',
  SHARED_BY_ME = 'shared_by_me',
  SHARED_WITH_ME = 'shared_with_me',
}

export const teamShareTypeIconMap = {
  [TeamShareTypeEnum.SHARED_BY_ME]: 'shared-by-me',
  [TeamShareTypeEnum.SHARED_WITH_ME]: 'shared-with-me',
  [TeamShareTypeEnum.PRIVATE]: undefined,
};

export const teamShareTypeIconTooltipMap = {
  [TeamShareTypeEnum.SHARED_BY_ME]: $localize`:@@teamsSharedByMeTeamStatusTooltip:Shared by me`,
  [TeamShareTypeEnum.SHARED_WITH_ME]: $localize`:@@teamsSharedWithMeTeamStatusTooltip:Shared with me`,
  [TeamShareTypeEnum.PRIVATE]: undefined,
};
